import React from 'react';
import { AiOutlineCheck } from 'react-icons/ai';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../styles/theme/foundation/colors';

import './styles.scss';

function Stepper({ activeStep, steps }) {
  return (
    <Flex alignItems="center" direction="row" justifyContent="space-between" mb={10} w="100%">
      {steps.map((step, idx) => (
        <div
          className={idx < activeStep ? 'stepper-item completed'
            : idx === activeStep ? 'stepper-item active' : 'stepper-item'}
          key={step}
        >
          <Box
            alignItems="center"
            bg={idx < activeStep ? 'success.primary.600' : 'white'}
            borderColor={idx <= activeStep ? colors.success.primary['600'] : colors.greyScale['500']}
            borderRadius="50px"
            borderWidth={idx >= activeStep ? '3px' : '0'}
            boxSize={6}
            className="stepper-circle"
            display="flex"
            justifyContent="center"
            mb={2}
            position="relative"
            textAlign="center"
            zIndex={5}
          >
            {activeStep > idx && <Icon as={AiOutlineCheck} color="white" height="17px" w="17px" />}
          </Box>
          <Text
            className="stepper-name"
            fontSize="sm"
          >
            {step}
          </Text>
        </div>
      ))}
    </Flex>
  );
}

Stepper.propTypes = {
  /** Current step */
  activeStep: PropTypes.number.isRequired,
  /** Array of step names. Stepper is only for flows with three or more steps */
  steps: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Stepper;
